import React from 'react';
import { useBusinessContext } from '../contexts/BusinessContext';
import { staticData, motivationalMessages } from '../data/staticData';
import './CountrySelectionDialog.css';

export function CountrySelectionDialog() {
  const { isDialogOpen, closeDialog, setBusinessDetails, openCountryDetailsDialog, setCurrentMessage } = useBusinessContext();

  const handleCountrySelect = (country: typeof staticData.countries[0]) => {
    setBusinessDetails({
      country: country.name,
      countryCode: country.code,
      flag: country.code,
    });
    setCurrentMessage(motivationalMessages.countrySelected);
    closeDialog();
    openCountryDetailsDialog();
  };

  if (!isDialogOpen) return null;

  return (
    <div className="country-selection-overlay" onClick={closeDialog}>
      <div className="country-selection-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="country-selection-header">
          <button className="country-selection-close" onClick={closeDialog}>
            ×
          </button>
          <div className="country-selection-logo">
            <h1 className="country-selection-logo-text">CSZGLOBAL</h1>
          </div>
        </div>

        <div className="country-selection-content">
          <div className="country-selection-title-section">
            <h2 className="country-selection-title">Create New Trends · Unleash New Power</h2>
            <p className="country-selection-subtitle">
              Global innovation: 168-minute website deployment
            </p>
            <div className="country-selection-separator" />
            <p className="country-selection-prompt">Select Country</p>
          </div>

          <div className="country-selection-grid">
            {staticData.countries.map((country) => (
              <button
                key={country.code}
                onClick={() => handleCountrySelect(country)}
                className="country-selection-item"
              >
                <div className="country-selection-flag">
                  <span className="country-flag-emoji">{country.flag}</span>
                </div>
                <span className="country-selection-name">{country.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

